import { render } from "./Comptables.vue?vue&type=template&id=59436776&scoped=true"
import script from "./Comptables.vue?vue&type=script&lang=js"
export * from "./Comptables.vue?vue&type=script&lang=js"

import "./Comptables.vue?vue&type=style&index=0&id=59436776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59436776"]])

export default __exports__